import {registerReactPartial} from '@github-ui/react-core/register-partial'
import {ReposOverview} from './ReposOverview'

registerReactPartial('repos-overview', {
  Component: ReposOverview,
})
